<script setup>
import { defineProps, defineEmits, defineOptions } from 'vue'

defineOptions({
    inheritAttrs: false
})

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: undefined
    },
    value: {
        type: [String, Number],
        default: undefined
    }
})

const emit = defineEmits([
    'update:modelValue',
    'change'
])

const handleChange = (event) => {
    let value = event.target.value

    if (value === 'null') {
        value = null
    }

    emit('update:modelValue', value)
    emit('change', event)
}
</script>

<template>
    <div class="app-select-wrapper position-relative" v-bind="{ ...$attrs, class: null }">
        <select v-if="props.modelValue !== undefined || value !== undefined" v-bind="$attrs" :value="modelValue ?? value" :class="[$attrs.class, 'form-select-custom cursor-pointer w-100']" @change="handleChange">
            <slot />
        </select>

        <select v-else v-bind="$attrs" :class="[$attrs.class, 'form-select-custom cursor-pointer w-100']" @change="handleChange">
            <slot />
        </select>

        <span class="seta-chevron"></span>
    </div>
</template>

<style>
.form-select-custom {
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    -o-appearance: none !important;
    appearance: none !important;

    width: 100% !important;
    display: block;
    padding-right: 35px !important;
    background-color: transparent !important;
    outline: none;
}

.seta-chevron {
    position: absolute;
    right: 15px;
    top: 45%;
    width: 8px;
    height: 8px;
    border-right: 2px solid #b9cdff;
    border-bottom: 2px solid #b9cdff;
    transform: translateY(-50%) rotate(45deg);
    pointer-events: none;
    z-index: 10;
}
</style>
